module.exports = __webpack_public_path__ + "img/478.e65a3f7e.png";